import { formatWeekdayDdMmYyyy, istDateInputValue } from "./formatDdMmYyyy";
/** Shared by Gap Analysis (Schedule Interviews) and Organizational Setup (Book meetings). */

export const MEETING_SCHEDULE_SOURCE_GAP_ANALYSIS = "gap_analysis";
export const MEETING_SCHEDULE_SOURCE_ORG_SETUP = "org_setup";

/** API / list row: legacy rows may omit scheduleSource — treat as gap workflow. */
export function meetingScheduleSource(m) {
  if (m && m.scheduleSource === MEETING_SCHEDULE_SOURCE_ORG_SETUP) return MEETING_SCHEDULE_SOURCE_ORG_SETUP;
  return MEETING_SCHEDULE_SOURCE_GAP_ANALYSIS;
}

export function isMeetingFromOrgSetup(m) {
  return meetingScheduleSource(m) === MEETING_SCHEDULE_SOURCE_ORG_SETUP;
}

export function isMeetingFromGapAnalysis(m) {
  return meetingScheduleSource(m) === MEETING_SCHEDULE_SOURCE_GAP_ANALYSIS;
}

/** Labels for SPOC / meeting-request cards (matches Gap Analysis Meeting requests tab). */
export const SPOC_MEETING_TYPE_LABELS = {
  in_person: "In-person Assessment",
  remote_video: "Virtual (Teams/Zoom)",
  hybrid: "Hybrid Assessment",
};

export function formatSpocMeetingDate(iso) {
  return formatWeekdayDdMmYyyy(iso);
}

/** Schedule stakeholder meeting — department dropdown; "Other" shows a text field. */
export const GAP_MEETING_DEPARTMENT_OPTIONS = [
  "IT Security",
  "HR",
  "Operations",
  "Finance",
  "Legal & Compliance",
  "Facilities",
  "Engineering / R&D",
  "Sales & Marketing",
  "Executive",
];

export const GAP_MEETING_TYPE_LABELS = {
  in_person: "In-person Assessment",
  remote_video: "Virtual Assessment (Teams/Zoom)",
  hybrid: "Hybrid Assessment",
};

export function meetingDateToInputValue(iso) {
  if (!iso) return "";
  try {
    // IST day, so the picker shows the same calendar day the list rows display (a date-only value keeps its own day).
    const v = istDateInputValue(iso);
    return v || (typeof iso === "string" ? iso.slice(0, 10) : "");
  } catch {
    return "";
  }
}

export function normalizeMeetingAttendees(raw) {
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (typeof raw === "string" && raw.trim()) {
    try {
      const p = JSON.parse(raw);
      return Array.isArray(p) ? p.filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function mapApiMeetingToScheduledRow(m) {
  const attendees = normalizeMeetingAttendees(m.attendees);
  return {
    id: m.id,
    title: m.title || "",
    date: meetingDateToInputValue(m.meetingDate),
    type: m.meetingType || "in_person",
    status: m.status || "scheduled",
    attendees,
    department: m.department || "",
    notes: m.notes || "",
    meetingLink: m.meetingLink || "",
    meetingLocation: m.meetingLocation || "",
    scheduleSource: meetingScheduleSource(m),
  };
}
